var addProduct =
{
    init: function () {
        this.createUserList();
        this.onClickList();
        this.searchUserList();
        this.onAddZoneplanProductList();
    },

    searchUserList: function () {
        $('body').on('keyup', 'input[type="search"].offcanvas-search__input', function () {

            var $container = $(this).closest('.offcanvas-search');
            var $list = $('.offcanvas-search__list', $container);
            var query = $(this).val().toLowerCase().replace(/\s+/g, '_');

            if (query !== "") {
                $('.offcanvas-search__item', $list).hide();
                $('li[data-list-name*="' + query + '"]', $list).show();
            } else {
                $('.offcanvas-search__item', $list).show();
            }
        }
    )},

    createUserList: function () {
        if ($('.offcanvas-search').length) {
            $('body').on('click', '.offcanvas-search__create', function () {
                var $container = $(this).closest('.offcanvas-search');
                var $list = $('.offcanvas-search__list', $container);
                var $create = $('.offcanvas-search__create', $container);
                var $confirm = $('.offcanvas-search__confirm-create', $container);
                var $new = $('.offcanvas-search__new', $container);
                var $input = $('.offcanvas-search__input', $new);

                $(this).toggleClass('hidden');
                $new.toggleClass('offcanvas-search__new--active');
                $input.focus();

                $input.focus(function () {
                    $('.offcanvas-search__error--no-input', $new).fadeOut();
                    $('.offcanvas-search__error--identical', $new).fadeOut();
                });
            });

            $('body').on('click', '.offcanvas-search__create-close', function () {
                var $container = $(this).closest('.offcanvas-search');
                var $list = $('.offcanvas-search__list', $container);
                var $create = $('.offcanvas-search__create', $container);
                var $confirm = $('.offcanvas-search__confirm-create', $container);
                var $new = $('.offcanvas-search__new', $container);
                var $input = $('.offcanvas-search__input', $new);

                $('.offcanvas-search__create').toggleClass('hidden');
                $new.toggleClass('offcanvas-search__new--active');
                $input.focus();

                $input.focus(function () {
                    $('.offcanvas-search__error--no-input', $new).fadeOut();
                    $('.offcanvas-search__error--identical', $new).fadeOut();
                });
            });

            $('body').on('click', '.offcanvas-search__confirm-create', function () {

                var $container = $(this).closest('.offcanvas-search');
                var $list = $('.offcanvas-search__list', $container);
                var $create = $('.offcanvas-search__create', $container);
                var $confirm = $('.offcanvas-search__confirm-create', $container);
                var $new = $('.offcanvas-search__new', $container);
                var $input = $('.offcanvas-search__input', $new);

                var $val = $input.val();
                var $valClass = $val.toLowerCase().replace(/\s+/g, '_');

                if ($val === '') {
                    $('.offcanvas-search__error--no-input', $new).fadeIn();

                } else if ($('.list-' + $valClass, $list).length) {
                    $('.offcanvas-search__error--identical', $new).fadeIn();

                } else {
                    addProduct.createList($val);  
                }            
            });
        }
    },

    createList: function ($val) {
        $.ajax({
            url: '/Umbraco/Api/ProductList/CreateProductList',
            type: 'POST',
            data: { listName: $val },
            dataType: 'json',
        }).done(function (data) {
            if ($(".product-feature__id").length > 0) {
                productOverview.searchModel.itemNumbers.push($(".product-feature__id").data("item-number"));
            }
            offCanvas.getUserProductLists();
        });
    },

    addProductsToUserList: function (listId) {
        productOverview.searchModel.isProductSearch = true;
        if ($(".dt-zoneplanner-").length > 0)
        {
            productOverview.searchModel.isProductSearch = false;
        }
        $.ajax({
            url: '/Umbraco/Api/ProductList/AddProducts',
            type: 'POST',
            data: { searchModel: productOverview.searchModel, listId: listId },
            dataType: 'text',
        }).done(function (data) {
            //TODO a better way to handle this
        })
    },

    onClickList: function () {
        $('body').on('click', ".offcanvas-search__product-list:not(.products-added)", function () {
            var listId = $(this).data("id");
            var listName = $(this).text();
            var basketUrl = $("#urlToBasket").val();

            //handle add to product list for zoneplanner
            if ($(".dt-zoneplanner-").length > 0)
            {
                //gets the product list from the csv file.
                $.ajax({
                    url: '/Umbraco/api/ZoneplannerCSV/GetProductsFromCSV?id=' + addProduct.zoneplannerId,
                    type: 'Get',
                }).done(function (data) {
                    productOverview.searchModel.itemNumbers = data;
                    addProduct.addProductsToUserList(listId);
                });
            }
            else {
                if ($(".product-feature__id").length > 0)
                {
                    productOverview.searchModel.itemNumbers = [($(".product-feature__id").data("item-number"))];
                }
                addProduct.addProductsToUserList(listId);
            }

            $(this).addClass('products-added');
            $(".icon-productlist").removeClass("product-added");                
            setTimeout(function(){
                $(".icon-productlist").addClass("product-added");
            },500);

            $('.offcanvas-search__add-confirm-list-name').html("<a href=\"" + basketUrl + "\">" + listName + "</a>");
            $('.offcanvas-search__add-confirm').addClass('offcanvas-search__add-confirm--active');

            $('.offcanvas').removeClass('offcanvas--active');

            $('.offcanvas-search__add-confirm-close').click(function () {
                $('.offcanvas-search__add-confirm').removeClass('offcanvas-search__add-confirm--active');
                $('.offcanvas-overlay').removeClass('offcanvas-overlay--active');
            });
        });
    },
    onAddZoneplanProductList: function ()
    {
        $(".addZoneplannProductsToList").click(function () {
            addProduct.zoneplannerId = $(this).data("id");
        })
    }
}

$(document).ready(function () {    
    addProduct.init();    
});